import { Stack, TextField } from '@mui/material';
import { DateRange } from '@mui/x-date-pickers-pro';
import dayjs, { Dayjs } from 'dayjs';
import { ChangeEvent, useEffect, useState } from 'react';
import { useMount } from 'react-use';
import { DATE_FORMAT } from 'v2/core/date/date';
import { SUPPORTED_INPUT_DATE_FORMATS } from '../constants';
import { SinceDateTimeRange } from '../types';
import { isValidDate } from './helpers';

interface SinceModeControlsProps {
  dateRange: DateRange<Dayjs | null>;
  timeRange: SinceDateTimeRange;
  onChange: (timeRange: SinceDateTimeRange) => void;
}

export function SinceModeControls({
  dateRange,
  onChange,
}: SinceModeControlsProps) {
  const [from, to] = dateRange;
  const [fromDateStrInput, setFromDateStrInput] = useState('');

  useMount(() => {
    if (from) {
      onChange({
        type: 'since',
        startAfter: from,
      });
    }
  });

  useEffect(() => {
    if (from?.isValid()) {
      setFromDateStrInput(from.tz().format(DATE_FORMAT));
    }
  }, [from]);

  function onFromDateChange(event: ChangeEvent<HTMLInputElement>) {
    const value = event.target.value;
    let updatedFrom: dayjs.Dayjs | null = dayjs(
      value,
      SUPPORTED_INPUT_DATE_FORMATS,
    );
    if (
      isValidDate({
        date: updatedFrom,
        maxDate: to,
      })
    ) {
      const year = updatedFrom.year();
      const month = updatedFrom.month();
      const date = updatedFrom.date();
      updatedFrom = updatedFrom
        .tz()
        .set('year', year)
        .set('month', month)
        .set('date', date)
        .startOf('day')
        .tz();
    } else {
      updatedFrom = null;
    }

    onChange({
      type: 'since',
      startAfter: updatedFrom,
    });

    // Required to preserve the actual value
    setFromDateStrInput(value);
  }

  return (
    <Stack spacing={1.5} direction="row" justifyContent="center">
      <TextField
        type={'text'}
        size="small"
        variant="outlined"
        label="Since"
        value={fromDateStrInput}
        onChange={onFromDateChange}
      />
    </Stack>
  );
}
